/**
 * @generated SignedSource<<1bb9fa1b09a7bff2ff4f4f3f7e1e3e17>>
 * @relayHash 534eaf1ce5dbcc2598b7e3e0061a838f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/GetHelpZendeskOrdersListQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskOrdersListQuery$variables = {
  isLoggedIn: boolean;
  searchTerm: string;
  sellerId: string;
  userId: string;
  viewName?: string | null;
};
export type GetHelpZendeskOrdersListQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskOrdersList_viewer">;
  };
};
export type GetHelpZendeskOrdersListQuery = {
  response: GetHelpZendeskOrdersListQuery$data;
  variables: GetHelpZendeskOrdersListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLoggedIn"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sellerId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewName"
},
v5 = [
  {
    "kind": "Literal",
    "name": "after",
    "value": ""
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  },
  {
    "kind": "Variable",
    "name": "sellerId",
    "variableName": "sellerId"
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  },
  {
    "kind": "Variable",
    "name": "viewName",
    "variableName": "viewName"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskOrdersListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "isLoggedIn",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GetHelpZendeskOrdersList_viewer"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "GetHelpZendeskOrdersListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "isLoggedIn",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v5/*:: as any*/),
                "concreteType": "TransactionsPaginatedSearchConnection",
                "kind": "LinkedField",
                "name": "transactionsPaginatedSearch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionsPaginatedSearchEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "size",
                                    "value": "small"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "firstPhotoWebPath",
                                "storageKey": "firstPhotoWebPath(size:\"small\")"
                              },
                              (v6/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCanceled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TransactionCurrentBuyerTimelineStatus",
                            "kind": "LinkedField",
                            "name": "currentBuyerTimelineStatus",
                            "plural": false,
                            "selections": (v7/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TransactionCurrentSellerTimelineStatus",
                            "kind": "LinkedField",
                            "name": "currentSellerTimelineStatus",
                            "plural": false,
                            "selections": (v7/*:: as any*/),
                            "storageKey": null
                          },
                          (v6/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*:: as any*/),
                "filters": [
                  "userId",
                  "sellerId",
                  "searchTerm",
                  "viewName"
                ],
                "handle": "connection",
                "key": "OrdersList_transactionsPaginatedSearch",
                "kind": "LinkedHandle",
                "name": "transactionsPaginatedSearch"
              }
            ]
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/GetHelpZendeskOrdersListQuery",
    "metadata": {},
    "name": "GetHelpZendeskOrdersListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ab2fe13c9545665348deae05d0f648c0";

export default node;
